module.exports={
    authorization: {
        all: 'All sizes',
        search:'Search',
        import:'Import',
        download:'Download',
        // scan:'扫描标签',
        // authorizationAll:'授权所有',
        table:{
        	index:'Number',
        	mac:'MAC address',
        	screenSize:'Display size(")',
        	battery:'Battery level(%)',
        	lastupdate:'Last communication time',
        	// operator:'Operating',
        	// authorization:'Authorization'
        },
        dialogAuthor:{ //授权弹框
            dialogTitle:'Authorization',
            dialogMsg:'Are you sure to authorize {mac}?'
        },
        dialogAuthorAll:{ //授权选中的所有标签弹框
            dialogTitle:'Authorization',
            dialogMsg:'Are you sure to authorize the selected tag?',
            hint:'Please select the label you want to authorize first!'
        },
        upload:{
            success:'Imported tags succeeded, successful {success}, repeated failures {fail}!',
            fail:'Importing tags failed!',
            msg:'Upload files can only be Excel spreadsheets'
        },
        permission:{
            addLabel:'新增标签'   //数据库字段，不可改
        },
        queryAuthor:{
            fail:'Query tag failed!'
        },
        cancel:'Cancel',
        sure:'OK',
        hint:'prompt'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/authorization.js